import React, { } from 'react';
import { Page, Navbar, LoginScreenTitle, Block, Button, Toolbar, Row, Col } from "framework7-react";
import logo from '../../src/img/logo/eatbids-sm-logo.png';

const PageCart = () => {
  return (
    <Page className='bg-white'>
      <Navbar title="My Cart" noShadow backLink="Back"/>
      <div className="otp-container mt-5">
      <Block>
      <LoginScreenTitle className="mt-5"><img src={logo} alt="eatbids"/></LoginScreenTitle>
      <h4 className='text-center'>Verify Email</h4>
      <p className='text-center'>Code is sent to email</p>
      <p className="text-center mt-5">Didn't recieve code? <a href="/register/">Request again</a></p>
      </Block>
      </div>
      <Toolbar tabbar noShadow bottom className='toolbar-cart'>
        <Block className='block-cart'>
          <Row>
            <Col width="50" medium="25">
              <Button fill large className='mt-1'> Checkout </Button>
            </Col>
            <Col width="50" medium="25">
              <p className='text-4 mt-3'>Subtotal: <b>$ 456.23</b></p>
            </Col>
          </Row>          
        </Block>        
      </Toolbar>
    </Page>
  );
};

export default PageCart;